const baseUrl = process.env.NODE_ENV === 'development' ? 'http://www-test.hadutech.net' : '';

export const ServerConfig = {
    PaymentUrl: baseUrl + '/overseas-payment-management/',
    BaseUrl: baseUrl + '/fund-cloud/',
    DinoUrl: baseUrl + '/dino-manage-web/'
}
